/* global $ */
/* eslint no-unused-vars: 0  */
/* eslint no-nested-ternary: 0  */

import { hasIOSupport } from '../helpers/feature-detects';
import { viewportHeight, viewportWidth } from '../helpers/dom-tools';

if (window.llItems.length) {
  $(window.llItems).each((i, el) => {
    $.get({ url: el.src, dataType: 'text' }).done((text) => {
      // console.log(text);
      const d = document.createElement('span');
      d.innerHTML = text;
      el.parentNode.replaceChild(d, el);
    });
  });
}

// moves data-src/sizes/scrset to native attributes
export const lazyLoadFromDataAttr = (el) => {
  const data = $(el).data();
  const { src, srcset, sizes } = data;
  // console.log({ data });
  if (src) {
    el.src = src;
  }
  if (srcset) {
    el.srcset = srcset;
  }
  if (sizes) {
    el.sizes = sizes;
  }
};

document.addEventListener('DOMContentLoaded', () => {
  const modules = document.querySelectorAll('[data-module]');
  if (hasIOSupport) {
    const moduleObserver = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          const { isIntersecting, target } = entry;
          if (isIntersecting) {
            $(target)
              .find('img,source')
              .each((i, el) => {
                lazyLoadFromDataAttr(el);
                observer.unobserve(target);
              });
          }
        });
      },
      {
        rootMargin: '-100px 0px -100px 0px',
        threshold: [0, 1],
      },
    );

    modules.forEach((v) => {
      moduleObserver.observe(v);
    });
  } else {
    $(modules)
      .find('img,source')
      .each((i, el) => {
        lazyLoadFromDataAttr(el);
      });
  }
});

/**
 * Simple lazy load.
 * Assumes a list of comma seperated image sizes on data-xlink attr.
 * See homepage blobs.
 */
const loadLazySvg = (svg) => {
  const base = ['768', '1250'];
  const $img = $('image', $(svg));
  const sizes = $img.attr('data-xlink').split(', ');

  const load = (index) => {
    // if exists, else fallback.
    const src = sizes[index]
      ? sizes[index]
      : sizes[index - 1]
      ? sizes[index - 1]
      : sizes[0];
    $img.attr('xlink:href', src);
  };

  const vw = viewportWidth();
  if (vw <= 768) {
    load(0);
  } else if (vw > 768 && vw < 1250) {
    load(1);
  } else if (vw >= 1250) {
    load(2);
  } else {
    load(1);
  }
};

const lazySVG = () => {
  const $image = $('.lazy-svg-image');

  $image.each(function() {
    const $this = $(this);
    // Lazy load.
    loadLazySvg($this);
  });
};

$(document).ready(() => {
  lazySVG();
});
